import React from 'react';

const DisabledLabel = ({children}) => <span style={{opacity: 0.65, cursor: 'pointer'}}>{children}</span>;

export default DisabledLabel;
